import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Gift, Plus, Trash2, Trophy, Power } from "lucide-react";
import { metricLabel } from "./shared";

const inp = "bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold focus:outline-none";
const BLANK = { title: "", metric: "on_time_pick", period: "monthly", prize: "", active: true };

function RewardForm({ onSaved }) {
  const [f, setF] = useState(BLANK);
  const save = async () => {
    try { await client.post("/workforce/rewards", f); toast.success("Reward added"); setF(BLANK); onSaved(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="surface p-4 grid sm:grid-cols-2 lg:grid-cols-5 gap-2" data-testid="wf-reward-form">
      <input className={inp} placeholder="Reward naam (e.g. Fastest Picker)" value={f.title} maxLength={80} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="wf-reward-title" />
      <select className={inp} value={f.metric} onChange={(e) => setF({ ...f, metric: e.target.value })} data-testid="wf-reward-metric">
        {Object.entries(metricLabel).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <select className={inp} value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} data-testid="wf-reward-period">
        <option value="weekly">Weekly</option><option value="monthly">Monthly</option>
      </select>
      <input className={inp} placeholder="Gift / prize (e.g. $50 bonus)" value={f.prize} maxLength={120} onChange={(e) => setF({ ...f, prize: e.target.value })} data-testid="wf-reward-prize" />
      <button onClick={save} disabled={f.title.trim().length < 2 || !f.prize.trim()} className="btn-gold px-3 py-2 text-xs flex items-center justify-center gap-1 disabled:opacity-50" data-testid="wf-reward-add"><Plus size={14} />Add reward</button>
    </div>
  );
}

function RewardCard({ rw, onChange }) {
  const lb = rw.leaderboard;
  const toggle = async () => { try { await client.put(`/workforce/rewards/${rw.id}`, { ...rw, active: !rw.active }); onChange(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async () => { if (!window.confirm("Reward delete karein?")) return; await client.delete(`/workforce/rewards/${rw.id}`); onChange(); };
  return (
    <div className={`surface ${rw.active ? "" : "opacity-60"}`} data-testid={`wf-reward-${rw.id}`}>
      <div className="px-4 py-3 border-b border-[color:var(--border-subtle)] flex items-center gap-2">
        <Gift size={16} className="text-gold shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-white text-sm font-semibold truncate">{rw.title}</div>
          <div className="text-[11px] text-slate-500">{metricLabel[rw.metric]} · {rw.period} · {lb.start} → {lb.end} · 🎁 {rw.prize}</div>
        </div>
        <button onClick={toggle} title={rw.active ? "Pause" : "Activate"} className={`p-1.5 ${rw.active ? "text-bull" : "text-slate-500"}`} data-testid={`wf-reward-toggle-${rw.id}`}><Power size={15} /></button>
        <button onClick={del} className="p-1.5 text-slate-500 hover:text-bear" data-testid={`wf-reward-del-${rw.id}`}><Trash2 size={15} /></button>
      </div>
      <div className="divide-y divide-[color:var(--border-subtle)]">
        {lb.rows.slice(0, 5).map((x, i) => (
          <div key={x.partner_id} className="px-4 py-2 flex items-center gap-2 text-sm">
            <span className={`w-5 font-mono ${i === 0 ? "text-gold" : "text-slate-500"}`}>{i + 1}</span>
            <span className="text-slate-200 flex-1 truncate">{x.name}</span>
            <span className="font-mono text-white">{x.value}</span>
          </div>
        ))}
        {!lb.rows.length && <div className="px-4 py-3 text-xs text-slate-500">Koi partner nahi</div>}
      </div>
    </div>
  );
}

export function RewardsTab() {
  const [d, setD] = useState(null);
  const load = () => client.get("/workforce/rewards").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d) return null;
  return (
    <div className="space-y-4">
      <RewardForm onSaved={load} />
      <div className="grid md:grid-cols-2 gap-3">{d.rewards.map((rw) => <RewardCard key={rw.id} rw={rw} onChange={load} />)}</div>
      {!d.rewards.length && <div className="text-sm text-slate-500" data-testid="wf-reward-empty">Abhi koi reward nahi. Upar se pehla reward banayein.</div>}
      {d.winners.length > 0 && (
        <div className="surface" data-testid="wf-winners">
          <div className="px-4 py-3 border-b border-[color:var(--border-subtle)] text-sm text-white flex items-center gap-2"><Trophy size={15} className="text-gold" />Past winners</div>
          {d.winners.map((w) => <div key={w.id} className="px-4 py-2 text-xs text-slate-300 border-b border-[color:var(--border-subtle)] last:border-0">{w.period_key} · <b className="text-white">{w.name}</b> — {w.title} ({w.value}) · 🎁 {w.prize}</div>)}
        </div>
      )}
      <p className="text-[11px] text-slate-500">Period khatam hone par (weekly = Sunday raat, monthly = mahine ki aakhri raat) top partner apne aap winner banta hai aur use Telegram + app pe message jata hai.</p>
    </div>
  );
}
